const UPDATES = [
  { date: '2026.07.28', title: '《相扑道》最新话更新上线', desc: '刃牙与横纲级力士的激战进入白热化阶段，新的格斗技巧震撼登场。' },
  { date: '2026.07.25', title: '刃牙外传《花山薰》新篇章追加', desc: '人气角色花山薰的外传故事迎来全新展开，揭秘他不为人知的过去。' },
  { date: '2026.07.22', title: '网站画质全面升级', desc: '全部刃牙漫画免费在线观看现已支持超高清画质，细节更加锐利清晰。' },
  { date: '2026.07.18', title: '《范马刃牙》经典战役回顾专题上线', desc: '精选父子决战篇十大经典对决，带你重温刃牙漫画的巅峰时刻。' },
  { date: '2026.07.15', title: '移动端下拉式阅读体验优化', desc: '手机阅读刃牙漫画更加流畅顺滑，翻页动画与加载速度全面提升。' },
  { date: '2026.07.12', title: '《刃牙道》宫本武藏篇高清重置', desc: '宫本武藏复活篇全部以高清画质重新上线，经典再度绽放。' },
  { date: '2026.07.08', title: '刃牙漫画角色图鉴功能上线', desc: '全面收录刃牙系列全部格斗家资料，角色关系一目了然。' },
  { date: '2026.07.05', title: '《刃牙II》死囚篇全话免费开放', desc: '五大死刑犯篇完整收录，无需注册即可畅读全部经典战役。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          更新动态
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10">
          刃牙漫画最新章节与平台动态速递
        </p>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-5">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative flex gap-5">
                <div className="hidden sm:flex flex-shrink-0 w-10 flex-col items-center">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 mt-1.5 z-10 relative"></div>
                </div>
                <div className="flex-1 bg-background-50 border border-background-200/80 rounded-xl p-4 md:p-5">
                  <span className="text-xs text-primary-600 font-semibold">{item.date}</span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mt-1 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}